/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DownloadDocumentResponse,
  ErrorResponseDto,
  ExportInboundOrderDetailsParams,
  ExportInboundOrdersParams,
  ExportOutboundOrdersParams,
  ExportStockParams,
  GetInboundOrderDetailsParams,
  GetInboundOrdersIdsParams,
  GetInboundOrdersOverviewParams,
  GetOutboundOrderDetailsParams,
  GetOutboundOrdersIdsParams,
  GetOutboundOrdersOverviewParams,
  GetStockOverviewParams,
  InboundOrderHeader,
  InboundOrderIdsPaginatedDto,
  InboundOrderLinesPaginatedDto,
  InboundOrderOverviewPaginatedDto,
  OutboundOrderHeader,
  OutboundOrderIdsPaginatedDto,
  OutboundOrderLinesPaginatedDto,
  OutboundOrderOverviewPaginatedDto,
  StockOverviewPaginatedDto,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Inventory<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Inventory
   * @name ExportInboundOrderDetails
   * @summary Export Inbound Order Details
   * @request GET:/v1/inventory/inbound/{id}/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportInboundOrderDetails = ({ id, ...query }: ExportInboundOrderDetailsParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/inventory/inbound/${id}/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name ExportInboundOrders
   * @summary Export all InboundOrders
   * @request GET:/v1/inventory/inbound/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportInboundOrders = (query: ExportInboundOrdersParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/inventory/inbound/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name ExportOutboundOrders
   * @summary Export all OutboundOrders
   * @request GET:/v1/inventory/outbound/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportOutboundOrders = (query: ExportOutboundOrdersParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/inventory/outbound/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name ExportStock
   * @summary Export all stock
   * @request GET:/v1/inventory/stock/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportStock = (query: ExportStockParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/inventory/stock/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetInboundOrderDetails
   * @summary Get Inbound Order Details
   * @request GET:/v1/inventory/inbound/{id}
   * @response `200` `InboundOrderLinesPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInboundOrderDetails = ({ id, ...query }: GetInboundOrderDetailsParams, params: RequestParams = {}) =>
    this.http.request<InboundOrderLinesPaginatedDto, ErrorResponseDto>({
      path: `/v1/inventory/inbound/${id}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetInboundOrderHeader
   * @summary Get Inbound Order Header
   * @request GET:/v1/inventory/inbound/{id}/header
   * @response `200` `InboundOrderHeader`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInboundOrderHeader = (id: string, params: RequestParams = {}) =>
    this.http.request<InboundOrderHeader, ErrorResponseDto>({
      path: `/v1/inventory/inbound/${id}/header`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetInboundOrdersIds
   * @summary Get all Inbound Orders ids
   * @request GET:/v1/inventory/inbound/ids
   * @response `200` `InboundOrderIdsPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInboundOrdersIds = (query: GetInboundOrdersIdsParams, params: RequestParams = {}) =>
    this.http.request<InboundOrderIdsPaginatedDto, ErrorResponseDto>({
      path: `/v1/inventory/inbound/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetInboundOrdersOverview
   * @summary Get all Inbound Orders
   * @request GET:/v1/inventory/inbound
   * @response `200` `InboundOrderOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getInboundOrdersOverview = (query: GetInboundOrdersOverviewParams, params: RequestParams = {}) =>
    this.http.request<InboundOrderOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/inventory/inbound`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetOutboundOrderDetails
   * @summary Get Outbound Order Details
   * @request GET:/v1/inventory/outbound/{id}
   * @response `200` `OutboundOrderLinesPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getOutboundOrderDetails = ({ id, ...query }: GetOutboundOrderDetailsParams, params: RequestParams = {}) =>
    this.http.request<OutboundOrderLinesPaginatedDto, ErrorResponseDto>({
      path: `/v1/inventory/outbound/${id}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetOutboundOrderHeader
   * @summary Get Outbound Order Header
   * @request GET:/v1/inventory/outbound/{id}/header
   * @response `200` `OutboundOrderHeader`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getOutboundOrderHeader = (id: string, params: RequestParams = {}) =>
    this.http.request<OutboundOrderHeader, ErrorResponseDto>({
      path: `/v1/inventory/outbound/${id}/header`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetOutboundOrdersIds
   * @summary Get all Outbound Orders ids
   * @request GET:/v1/inventory/outbound/ids
   * @response `200` `OutboundOrderIdsPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getOutboundOrdersIds = (query: GetOutboundOrdersIdsParams, params: RequestParams = {}) =>
    this.http.request<OutboundOrderIdsPaginatedDto, ErrorResponseDto>({
      path: `/v1/inventory/outbound/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetOutboundOrdersOverview
   * @summary Get all Outbound Orders
   * @request GET:/v1/inventory/outbound
   * @response `200` `OutboundOrderOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getOutboundOrdersOverview = (query: GetOutboundOrdersOverviewParams, params: RequestParams = {}) =>
    this.http.request<OutboundOrderOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/inventory/outbound`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Inventory
   * @name GetStockOverview
   * @summary Get Stock Overview
   * @request GET:/v1/inventory/stock
   * @response `200` `StockOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getStockOverview = (query: GetStockOverviewParams, params: RequestParams = {}) =>
    this.http.request<StockOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/inventory/stock`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
